export default __webpack_public_path__ + "a9d0e7940aa93d83a225d7116dd82209.jpg";